import { Text } from "@mantine/core";
import type { ReactNode } from "react";

interface IContainerTextProps {
  children: ReactNode;
  className?: string;
}

const ContainerText: React.FC<IContainerTextProps> = ({
  children,
  className,
}) => {
  return (
    <Text
      inherit
      classNames={{
        root: `text-primary-white font-inter px-5 py-3 bg-primary-background rounded-sm ${className}`,
      }}
    >
      {children}
    </Text>
  );
};

export default ContainerText;
